import React from 'react';
import { RootineTabs } from '../../../atoms/RootineTabs';
import { colors, theme } from '../../../utils/theme';
import { StressResources } from './StressResources';
import {
  RelatedContentProps,
  StressRelatedContent,
} from './StressRelatedContent';

export const ResourcesAndContentTabs = ({
  relatedContent,
}: {
  relatedContent: RelatedContentProps;
}): JSX.Element => {
  return (
    <>
      <RootineTabs
        tabs={{
          Resources: <StressResources />,
          'Related Content': (
            <StressRelatedContent relatedContent={relatedContent} />
          ),
        }}
        hideTabs={false}
        tabsProps={{
          centered: false,
          variant: 'fullWidth',
        }}
        tabProps={{
          sx: {
            fontSize: { xs: 16, md: 18 },
            textTransform: 'none',
            color: colors.greys.GREY_550,
            fontWeight: theme.typography.light,
            '&.Mui-selected': {
              color: colors.greys.TEXT_BLACK,
              fontWeight: theme.typography.medium,
            },
          },
        }}
        analyticsData={{
          data: {
            component: 'Resources And Related Content',
            feature: 'Stress Insights',
          },
        }}
      />
    </>
  );
};
